import { ErrorText } from '@/components/basicComponents/input';
import RadioButton from '@/components/basicComponents/radioButton';
import Select from '@/components/basicComponents/select';
import { createSimpleSelectOption } from '@/components/basicComponents/select/utils';
import Label from '@/components/basicComponents/label';
import { blinkingFrame } from '@/components/table/styles';
import { TwoColumnWrapper } from '@/components/transactions-page/generateSignaturePacket-page/templateComponents/styles';
import { useResponsive } from '@/hooks/use-responsive';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { AddButton } from './addButton';
import { IListData } from './types';
import { addStrategies, delStrategies, onChangeStrategies } from './utils';

interface RadioWithDynamicSelectsProps {
  radioOptions: string[];
  selectedRadioOption: string;
  radioLabel?: string;
  radioError?: string;
  dynamicItems: IListData;
  setDynamicItems: Dispatch<SetStateAction<IListData>>;
  handleRadioChange: (value: string) => void;
}

export const RadioWithDynamicSelects = ({
  radioOptions,
  selectedRadioOption,
  radioLabel,
  radioError,
  dynamicItems,
  setDynamicItems,
  handleRadioChange
}: RadioWithDynamicSelectsProps) => {
  const { isMobile } = useResponsive();

  return (
    <div>
      <TwoColumnWrapper isMobile={isMobile}>
        <RadioButtonWrapper isMobile={isMobile}>
          {radioLabel && <Label size="md">{radioLabel}</Label>}
          {radioOptions.map((option, index) => (
            <RadioButton
              key={option + index}
              name={option}
              radioButtonText={option}
              selectedOption={selectedRadioOption}
              handleRadioChange={(event) => handleRadioChange(event.target.value)}
            />
          ))}
          {radioError && <ErrorText size="md">{radioError}</ErrorText>}
        </RadioButtonWrapper>
      </TwoColumnWrapper>
      {selectedRadioOption === radioOptions[1] && (
        <TwoColumnWrapper isMobile={isMobile}>
          <DynamicSelectsWrapper>
            {dynamicItems.chosen.map((el, index) => (
              <DynamicSelectWrapper key={`advisoryFirm-${index}`}>
                <Select
                  value={dynamicItems.chosen[index]}
                  previewValue={dynamicItems.chosen[index]}
                  setValue={(value) => onChangeStrategies(value, index, dynamicItems, setDynamicItems)}
                  options={dynamicItems.list.map((item) => createSimpleSelectOption(item))}
                  styleType={dynamicItems.chosen[dynamicItems.chosen.length - 1] !== el ? 'disabled' : 'default'}
                  size="md"
                  withSearch
                />
                <DeleteDynamicItem onClick={() => delStrategies(el, index, dynamicItems, setDynamicItems)}>
                  <img src="/static/icons/blue-cross.svg" alt="cross" />
                </DeleteDynamicItem>
              </DynamicSelectWrapper>
            ))}
            {dynamicItems.list.length && dynamicItems.chosen[dynamicItems.chosen.length - 1] !== '' ? (
              <AddButton text="Add" onClick={() => addStrategies(dynamicItems, setDynamicItems)} />
            ) : (
              <></>
            )}
          </DynamicSelectsWrapper>
        </TwoColumnWrapper>
      )}
    </div>
  );
};

const RadioButtonWrapper = styled.div<{ isMobile: boolean }>`
  color: ${({ theme }) => theme.font.base};
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
`;

export const DynamicSelectsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const DynamicSelectWrapper = styled.div<{ loading?: boolean | number }>`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
  position: relative;

  opacity: ${({ loading }) => (loading ? 0.5 : 1)};
  pointer-events: ${({ loading }) => (loading ? 'none' : 'auto')};
  animation: ${({ loading }) => (loading ? blinkingFrame : null)} 1.5s infinite;
`;

export const DeleteDynamicItem = styled.div`
  position: relative;
  top: 3px;
  padding-left: 15px;
  cursor: pointer;
`;
